module.exports = __webpack_public_path__ + "static/media/preview1-large.854b44ea.jpg";